import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Chip,
  Divider,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { StatusAndNote } from "../StatusAndNote";
import { Add, Delete, InfoOutlined } from "@mui/icons-material";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import { PlanoDeTratamentoHistory } from "./PlanodeTratamentoHistory";

import { useMedicalCareContext } from "../../../../contexts/MedicalCareContext";
import { InputText } from "../../../ClinicalRegister/components/QuestionnaireViewer/components/Form";
import { Controller } from "react-hook-form";
import { useQuestionnaireContext } from "../../../../contexts/QuestionnaireContext";
import { useSessionContext } from "../../../../contexts/SessionContext";
import dayjs from "dayjs";

export function PlanosDeTratamento() {
  const styleType: any = {
    "long-term": "#183B56",
    "short-term": "#5F6C85",
  };

  const { response } = useQuestionnaireContext();
  const { control, unregister, carePlan, setCarePlan } =
    useMedicalCareContext();
  const { user } = useSessionContext();

  const responseEntries = response?.entry?.map((el: any) => el?.resource);

  const treatmentPlansResponses = responseEntries?.map((el: any) => {
    const awnserDate = el?.authored;
    const filterItens = el?.item
      ?.filter((e: any) => e?.text === "Planos de tratamento")?.[0]
      ?.item?.filter((subItem: any) => {
        return subItem?.item?.[0]?.answer;
      });
    const displayReferences = el?.item?.filter(
      (e: any) => e?.linkId === "displayReferences"
    )?.[0]?.item;
    const displayInfo = {
      healthcare: displayReferences?.[0]?.answer?.[0]?.valueString || "",
      practitioner: displayReferences?.[1]?.answer?.[0].valueString || "",
      identifier: el?.author?.reference?.split("-")?.[1],
    };
    return { awnserDate, filterItens, displayInfo };
  });

  const flatOpenItens = treatmentPlansResponses
    ?.filter((el: any) => el.filterItens?.length && el.filterItens)
    ?.flatMap((item: any) => {
      const auxItem = item?.filterItens?.map((response: any) => {
        return {
          ...response,
          displayInfo: item?.displayInfo,
          awnserDate: item?.awnserDate,
        };
      });

      return auxItem;
    });

  const auxVerify = flatOpenItens?.filter((e: any) => {
    const value = e?.item?.[0]?.answer?.[0]?.valueString;
    const status = e?.item?.[2]?.answer?.[0]?.valueCoding;

    const auxDuplicate = flatOpenItens?.some((el: any) => {
      const valueToCompare = el?.item?.[0]?.answer?.[0]?.valueString;
      const statusToCompare = el?.item?.[2]?.answer?.[0]?.valueCoding;

      // console.log("it", item.includes(comparação));
      // console.log("has", hasResponse);
      // console.log("inter", !item.includes(comparação) && !hasResponse);
      // console.log("---");

      return statusToCompare && valueToCompare.includes(value);
    });

    return !auxDuplicate && !status;
  });

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setCarePlan([...carePlan, ""]);
    }
  };

  return (
    <>
      <Stack
        spacing={1}
        width="100%"
        sx={{ maxHeight: "60vh", overflow: "auto", padding: 2 }}
      >
        {carePlan?.map((el: any, index: number) => (
          <>
            {el !== undefined && (
              <>
                <Controller
                  name={`newPlan.${index}.prazo`}
                  control={control}
                  render={({ field }) => (
                    <>
                      <RadioGroup
                        row
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        aria-label="position"
                        sx={{ width: "100%" }}
                        {...field}
                        value={field.value ?? ""}
                      >
                        <FormControlLabel
                          key={1}
                          value={1}
                          control={<Radio />}
                          label="Longo prazo"
                        />
                        <FormControlLabel
                          key={2}
                          value={2}
                          control={<Radio />}
                          label="Curto prazo"
                        />
                      </RadioGroup>
                    </>
                  )}
                />

                <Stack
                  width="100%"
                  justifyContent="space-between"
                  spacing={1}
                  direction="row"
                >
                  <InputText
                    key={index}
                    label="Plano de tratamento"
                    name={`newPlan.${index}.plano`}
                    control={control}
                    autoFocus
                    onKeyDown={handleKeyDown}
                    multiline={true}
                  />
                  {carePlan?.filter((el: any) => el !== undefined)?.length >
                    1 && (
                    <IconButton
                      onClick={() => {
                        setCarePlan((prevItems: any) => {
                          const updatedItems = [...prevItems]; // Faz uma cópia do array
                          updatedItems[index] = undefined; // Altera o item específico
                          return updatedItems; // Retorna o novo array modificado
                        });
                        unregister(`newPlan.${index}.plano`);
                        unregister(`newPlan.${index}.prazo`);
                      }}
                    >
                      <Delete sx={{ color: "red" }} />
                    </IconButton>
                  )}
                </Stack>
              </>
            )}
          </>
        ))}

        <Stack width="100%" direction="row" justifyContent="right">
          <Button
            sx={{ width: "fit-content" }}
            onClick={() => {
              setCarePlan([...carePlan, ""]);
            }}
            variant="text"
          >
            <Add /> Novo plano
          </Button>
        </Stack>

        <Divider orientation="horizontal" />
        <Stack direction="row" gap={1} alignItems="center">
          <Typography
            variant="body1"
            sx={{ my: 2, fontWeight: 500, fontSize: 16, color: "#555" }}
          >
            Lista de Planos em aberto
          </Typography>
          <Chip
            label={auxVerify?.length}
            size={"small"}
            sx={{ fontWeight: 500, fontSize: 12 }}
          />
        </Stack>

        {auxVerify?.map((el: any, index: number) => {
          return (
            <Accordion
              defaultExpanded={index === 0}
              sx={{
                width: "100%",
                boxShadow: "1px 1px 16px 1px rgba(0, 0, 0, 0.1)",
                position: "initial",
                border: "1px solid",
                borderColor: "neutral200.main",
                borderRadius: 1,
              }}
            >
              <AccordionSummary
                expandIcon={<GridExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Stack
                  direction="row"
                  width="100%"
                  justifyContent="space-between"
                >
                  {el?.item?.[0]?.answer?.[0]?.valueString.length > 100 ? (
                    <Tooltip
                      placement="right"
                      title={el?.item?.[0]?.answer?.[0]?.valueString}
                      slotProps={{
                        popper: {
                          modifiers: [
                            {
                              name: "offset",
                              options: {
                                offset: [-20, -40],
                              },
                            },
                          ],
                        },
                      }}
                    >
                      <Typography
                        fontWeight={500}
                        sx={{ color: "#555", wordBreak: "break-word" }}
                      >
                        {el?.item?.[0]?.answer?.[0]?.valueString.substring(
                          0,
                          70
                        )}
                        ...
                      </Typography>
                    </Tooltip>
                  ) : (
                    <Typography fontWeight={500} sx={{ color: "#555" }}>
                      {el?.item?.[0]?.answer?.[0]?.valueString}
                    </Typography>
                  )}

                  <Stack direction="row" spacing={2}>
                    <Chip
                      label={el?.item?.[1]?.answer?.[0]?.valueCoding?.display}
                      size="small"
                      variant="outlined"
                      sx={{
                        color:
                          styleType[
                            el?.item?.[1]?.answer?.[0]?.valueCoding?.code
                          ],
                        borderColor:
                          styleType[
                            el?.item?.[1]?.answer?.[0]?.valueCoding?.code
                          ],
                        borderRadius: 2,
                        marginBottom: 1,
                        width: "fit-content",
                      }}
                    />
                    {el?.displayInfo?.healthcare && (
                      <Chip
                        label={
                          el?.displayInfo?.healthcare || "Sem especialidade"
                        }
                        size="small"
                        sx={{
                          color: el?.displayInfo?.healthcare
                            ? "neutral700.main"
                            : "neutral500.main",

                          fontWeight: 500,
                          backgroundColor: el?.displayInfo?.healthcare
                            ? ""
                            : "#f1f1f1",
                          width: "fit-content",
                        }}
                      />
                    )}
                    <Chip
                      label={dayjs(el?.awnserDate)
                        ?.format("DD MMM YYYY")
                        ?.toUpperCase()}
                      size="small"
                      sx={{ fontWeight: 500, fontSize: 12, color: "#555" }}
                    />
                  </Stack>
                </Stack>
              </AccordionSummary>
              <AccordionDetails>
                {el?.displayInfo?.identifier === user?.username ? (
                  <StatusAndNote
                    index={index}
                    type="CarePlans"
                    answer={`${el?.item?.[0]?.answer?.[0]?.valueString};${el?.item?.[1]?.answer?.[0]?.valueCoding?.code}`}
                  />
                ) : (
                  <Stack
                    direction="row"
                    //bgcolor="primary200.main"
                    // bgcolor={bgColor ? `${bgColor}` : "transparent"}
                    alignItems="center"
                    spacing={1}
                    width="100%"
                    height="60px"
                    justifyContent="left"
                  >
                    <InfoOutlined />
                    <Typography variant="subtitle2" fontWeight={400}>
                      Conduta adicionada por outro profissional
                    </Typography>
                  </Stack>
                )}
              </AccordionDetails>

              <Stack
                sx={{ padding: 2 }}
                direction="row"
                width="100%"
                alignItems="center"
              >
                {el?.displayInfo?.practitioner && (
                  <Typography
                    color="neutral700.main"
                    sx={{ fontWeight: 500, fontStyle: "italic", fontSize: 12 }}
                  >
                    Dr. {el?.displayInfo?.practitioner}
                  </Typography>
                )}
              </Stack>
            </Accordion>
          );
        })}
      </Stack>
      <Stack width="90%" overflow="auto" maxHeight="60vh" paddingRight={3}>
        <PlanoDeTratamentoHistory />
      </Stack>
    </>
  );
}
